import { Injectable } from '@angular/core';
import { FieldAgentClient, GetCustomerNotepadItemsRequest, CustomerNotepad, NotepadTypeApplyTo } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, NotepadTypeNames } from 'ep-bt-controls';
import { Time } from '@angular/common';
import { EpbtFaFilterService } from './epbt-fa-filter.service';
import {
  PagingParameters, SortParameters, SortParametersDirection, GetCustomerNotepadItemsRequestConsumer
} from 'ep-bt-field-agent-proxy';
import { EpbtFaCustomerService } from './epbt-fa-customer.service';
import { EpbtFieldAgentService } from './epbt-field-agent.service';
import { EpbtFaSortService } from './epbt-fa-sort.service';




@Injectable({
  providedIn: 'root'
})
export class EpbtFaNotepadService {

  isCalendar = false;

  selectedCalendarDates: any;
  CustomerNotepad: CustomerNotepad;
  date: Date;
  time: Time;
  followUpDate: Date;
  followUpTime: Time;
  startDate: Date;
  startTime: Time;
  endDate: Date;
  endTime: Time;

  webTrackUser: any;
  customerNotepadItemsRequest: GetCustomerNotepadItemsRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;
  public pageSize = 10;

  constructor(private client: FieldAgentClient, private config: BistrackConfig, private faService: EpbtFieldAgentService,
    public customerService: EpbtFaCustomerService, private sortService: EpbtFaSortService,
    private filterService: EpbtFaFilterService) { }


  getCustomerNotepadItems(customerNotepadItemsRequest: GetCustomerNotepadItemsRequest,
    subscribe: (customerNotepadsResponse) => void) {

    this.client.getCustomerNotepadItems(customerNotepadItemsRequest).subscribe(customerNotepadsResponse => {
      subscribe(customerNotepadsResponse);
    });
  }

  getCustomerNotepadByNotepadId(notepadId: number,
    subscribe: (customerNotepadResponse) => void) {

    this.client.getCustomerNotepadItem(notepadId).subscribe(customerNotepadResponse => {
      subscribe(customerNotepadResponse);
    });
  }

  getCustomerNotepads(searchString: string, customerId: number, subscribe: (customer: any) => void) {

    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });


    // search start

    this.customerNotepadItemsRequest = new GetCustomerNotepadItemsRequest();
    this.customerNotepadItemsRequest.currentUser = this.webTrackUser;
    this.customerNotepadItemsRequest.currentUser.customer.customerId = customerId;
    this.paging = new PagingParameters();
    this.paging.count = this.pageSize;
    this.customerNotepadItemsRequest.pagingParameters = this.paging;


    this.sort = new SortParameters();
    if (this.customerService.isNotepadDashboard) {
      this.sort.sortColumn = this.sortService.dashboardNotepadSortValue; // "DateTimeCreated";
      this.sort.direction = this.sortService.dashboardNotepadDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      this.sort.sortColumn = this.sortService.customerNotepadSortValue; // "DateTimeCreated";
      this.sort.direction = this.sortService.customerNotepadDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }
    this.customerNotepadItemsRequest.sortParameters = this.sort;

    // filter params

    const seartype = this.GetNoteTypeCriteriaValue();
    this.customerNotepadItemsRequest.searchType = seartype ? seartype : 'AllNotes';
    this.customerNotepadItemsRequest.searchContact = 'AllContacts';
    if (this.customerService.isNotepadDashboard) {
      this.customerNotepadItemsRequest.searchMonths = this.filterService.selectedDashboardDateOptionId ? this.filterService.selectedDashboardDateOptionId : 'AllDates';
      this.customerNotepadItemsRequest.searchValue = searchString == undefined ? this.filterService.notepadDashboardSubject : searchString;
      this.customerNotepadItemsRequest.customerSearchText = this.filterService.notepadDashboardCustomer ? this.filterService.notepadDashboardCustomer : '';
      this.filterService.notepadDashboardSubject = searchString == undefined ? this.filterService.notepadDashboardSubject : searchString;
    } else {
      this.customerNotepadItemsRequest.searchMonths = this.filterService.selectedDateOptionId ? this.filterService.selectedDateOptionId : 'AllDates';
      this.customerNotepadItemsRequest.searchValue = searchString == undefined ? this.filterService.notepadSubject : searchString;
      this.filterService.notepadSubject = searchString == undefined ? this.filterService.notepadSubject : searchString;
    }

    this.customerNotepadItemsRequest.consumer = GetCustomerNotepadItemsRequestConsumer.BisTrackCloud;

    this.client.getCustomerNotepadItems(this.customerNotepadItemsRequest).subscribe(notepadRes => {
      // var notepadList = notepadRes.lines;
      // console.log(notepadRes);
      // if (notepadRes && notepadRes.lines && notepadRes.lines.length == 1) {
      //   this.router.navigate(['/home/notepad/addnotepad', notepadRes.lines[0].customerID, notepadRes.lines[0].customerNotepadID]);
      // }
      // else {
      //   this.updateGridData();
      // }
      if (notepadRes && notepadRes.lines.length == 1) {
        subscribe(notepadRes.lines[0]);
      } else {
        subscribe(false);
      }

    });
  }

  private GetNoteTypeCriteriaValue(): string {
    const noteTypeFilter = this.customerService.isNotepadDashboard ? this.filterService.selectedDashboardNotepadType : this.filterService.selectedNotepadType;
    let result: string;
    if (noteTypeFilter) {
      if (noteTypeFilter.systemDefined) {
        if (noteTypeFilter.name == NotepadTypeNames.All) {
          result = 'AllNotes';
        } else if (noteTypeFilter.name == NotepadTypeNames.FollowUp) {
          result = 'FollowUp';
        } else if (noteTypeFilter.name == NotepadTypeNames.System) {
          result = 'SystemNotes';
        } else if (noteTypeFilter.name == NotepadTypeNames.CreditControl) {
          // 119324 QC82
          result = 'CreditControl';
        } else if (noteTypeFilter.name == NotepadTypeNames.Appointment) {
          result = 'Appointments';
        } else if (noteTypeFilter.name == NotepadTypeNames.Event) {
          result = 'Events';
        } else if (noteTypeFilter.name == NotepadTypeNames.CampaignNotes) {
          result = noteTypeFilter.notepadTypeID.toString();
        } else if (noteTypeFilter.applyTo == NotepadTypeApplyTo.Customer && noteTypeFilter.notepadTypeID > 0) {
          // Unfortunately, that test is as specific as we can get in identifying the 'Outlook message' NotepadType.
          //  The code that looks for it elsewhere uses the same test: it's in the NotepadType table,
          //  its ApplyTo is Customers, and its SystemDefined value is 1.  I've added a comment in
          //  CRMDataGateway.GetCustomerNotepadItems() about how weak this association is.
          result = 'Outlook';
        } else {
        }
      } else {
        result = noteTypeFilter.notepadTypeID.toString();
      }
    }
    return result;
  }

}
